/* Domalune : choix de la taille de chaque pod au même endroit (Pod 1, Pod 2).
   Remplace les boutons de taille par un menu "Pod 1" dans le bloc de choix par pod. */
(function () {
  var H_ONE = 'Choisissez la taille de votre pod';
  var H_MANY = 'Choisissez la taille de chaque pod';
  var H_ONE_C = 'Choisissez la taille et la couleur de votre pod';
  var H_MANY_C = 'Choisissez la taille et la couleur de chaque pod';
  var SOLD = (window.BB && window.BB.strings && window.BB.strings.soldOut) || 'Épuisé';

  if (!document.getElementById('dm-pick-css')) {
    var st = document.createElement('style');
    st.id = 'dm-pick-css';
    st.textContent =
      '.dm-pick-on .pdp__opts .opt:not(.opt--colour){display:none}' +
      '.dm-pick__head{display:flex;align-items:baseline;justify-content:space-between;gap:12px;flex-wrap:wrap}' +
      '.dm-pick__head .tier-pick__h{margin:0}' +
      '.dm-pick__head .opt__guide{font-size:14px;white-space:nowrap;text-decoration:underline;text-underline-offset:3px;color:inherit}';
    document.head.appendChild(st);
  }

  function enhance(box) {
    if (!box || box.dataset.dmPick) return;
    var wrap = box.querySelector('[data-tier-pick-wrap]');
    var opts = box.querySelector('.pdp__opts');
    if (!wrap || !opts) return;
    var fieldsets = Array.prototype.slice.call(opts.querySelectorAll('.opt[data-opt-index]'));
    var row1 = wrap.querySelector('[data-pick-row="1"]');
    var main = row1 && row1.querySelector('.tier-pick__main');
    if (!fieldsets.length || !main) return;
    box.dataset.dmPick = '1';

    // En-tête : titre + lien "Guide des tailles" (ouvre la même fenêtre qu'avant)
    var h = wrap.querySelector('.tier-pick__h');
    if (!h) {
      h = document.createElement('p');
      h.className = 'tier-pick__h';
    }
    var head = document.createElement('div');
    head.className = 'dm-pick__head';
    wrap.insertBefore(head, wrap.firstChild);
    head.appendChild(h);
    var guide = opts.querySelector('.opt__guide');
    if (guide) {
      var g = guide.cloneNode(true);
      g.setAttribute('data-size-guide', '');
      g.setAttribute('aria-haspopup', 'dialog');
      g.setAttribute('aria-controls', 'bb-size-guide');
      head.appendChild(g);
    }

    // Ligne "Pod 1" : un menu par option, relié aux boutons d'origine (masqués)
    var label1 = row1.querySelector('.tier-pick__label');
    var label1Text = label1 ? label1.textContent : 'Pod 1';
    var sels = document.createElement('span');
    sels.className = 'tier-pick__sels';
    var selects = fieldsets.map(function (fs) {
      var sel = document.createElement('select');
      sel.className = 'field tier-pick__sel';
      var name = (fs.querySelector('.opt__legend span') || {}).textContent || '';
      sel.setAttribute('aria-label', label1Text + ' : ' + name.split(':')[0].trim());
      fs.querySelectorAll('[data-opt-value]').forEach(function (btn) {
        var o = document.createElement('option');
        o.value = btn.dataset.optValue;
        o.textContent = btn.dataset.optValue;
        sel.appendChild(o);
      });
      sel.addEventListener('change', function () {
        var btns = fs.querySelectorAll('[data-opt-value]');
        for (var i = 0; i < btns.length; i++) {
          if (btns[i].dataset.optValue === sel.value) { btns[i].click(); break; }
        }
      });
      sels.appendChild(sel);
      return { sel: sel, fs: fs };
    });
    main.parentNode.replaceChild(sels, main);
    box.classList.add('dm-pick-on');

    function sync() {
      var t = box.querySelector('[data-tier]:checked');
      var qty = t ? Number(t.dataset.tierQty) || 1 : 1;
      var isQty = !t || t.dataset.tierType === 'qty';
      wrap.hidden = !isQty;
      row1.hidden = !isQty;
      var hasC = !!opts.querySelector('.opt--colour[data-opt-index]');
      h.textContent = qty > 1 ? (hasC ? H_MANY_C : H_MANY) : (hasC ? H_ONE_C : H_ONE);
      if (label1) label1.textContent = qty > 1 ? label1Text : label1Text.replace(/\s*1$/, '');
      selects.forEach(function (p) {
        p.fs.querySelectorAll('[data-opt-value]').forEach(function (btn) {
          var o = null;
          for (var i = 0; i < p.sel.options.length; i++) {
            if (p.sel.options[i].value === btn.dataset.optValue) o = p.sel.options[i];
          }
          if (!o) return;
          o.disabled = !!btn.disabled;
          o.textContent = btn.dataset.optValue + (btn.disabled ? ' — ' + SOLD : '');
          if (btn.getAttribute('aria-pressed') === 'true') p.sel.value = btn.dataset.optValue;
        });
      });
    }
    box.addEventListener('variant:change', sync);
    box.querySelectorAll('[data-tier]').forEach(function (r) { r.addEventListener('change', sync); });
    sync();
  }

  function init(root) {
    (root || document).querySelectorAll('bb-buybox').forEach(enhance);
  }

  var ready = window.customElements ? customElements.whenDefined('bb-buybox') : Promise.resolve();
  ready.then(function () { requestAnimationFrame(function () { init(); }); });
  document.addEventListener('shopify:section:load', function (e) {
    ready.then(function () { requestAnimationFrame(function () { init(e.target); }); });
  });
})();
